import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { getCardMediums } from 'lib/product';
import { CGProduct } from 'types/shopify';
import ProductGridItem from './ProductGridItem';
import orderBy from 'lodash/orderBy';
import NoResults from './NoResults';

interface ProductGridProps {
  filterQuery?: string;
  filterMedium?: 'all' | 'physical' | 'digtal';
  order?: 'popular' | 'alphabetical';
  products: CGProduct[];
}

/**
 * Simple search engine... check the product title, tags & description for a match
 * @param product
 * @param query
 * @returns
 */
const productMatchesQuery = (product: CGProduct, query: string): boolean => {
  if (product.handle.toLowerCase().includes(query)) return true;
  if (product.title.toLowerCase().includes(query)) return true;
  if (product.tags.join(',').toLowerCase().includes(query)) return true;
  if (product.description.toLowerCase().includes(query)) return true;
  return false;
};

const ProductGrid: React.FC<ProductGridProps> = ({ products, filterQuery, filterMedium, order }) => {
  const formattedQuery = filterQuery?.toLowerCase().trim();
  let filteredProducts = products.filter((product) => {
    let include = true;
    if (filterMedium && filterMedium !== 'all' && getCardMediums(product, true).indexOf(filterMedium) === -1) include = false;
    if (formattedQuery && formattedQuery.length && !productMatchesQuery(product, formattedQuery)) include = false;
    return include;
  });
  let orderedProducts = order === 'alphabetical' ? orderBy(filteredProducts, [(p) => p.title.toLowerCase()], ['asc']) : filteredProducts;

  if (!orderedProducts.length) return <NoResults searchQuery={filterQuery} />;

  return (
    <Box>
      <Grid container spacing={1}>
        {orderedProducts.map((product, idx) => (
          <Grid item key={idx} xs={6} sm={4} md={3}>
            <ProductGridItem product={product} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProductGrid;
